export class DataCatalogRowPredicate {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "column",
            "baseName": "column",
            "type": "string",
            "format": ""
        },
        {
            "name": "operator",
            "baseName": "operator",
            "type": "DataCatalogRowOperator",
            "format": ""
        },
        {
            "name": "values",
            "baseName": "values",
            "type": "Array<DataCatalogRowLiteral>",
            "format": ""
        },
        {
            "name": "columnType",
            "baseName": "columnType",
            "type": "DataCatalogColumnType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogRowPredicate.attributeTypeMap;
    }
    constructor() {
    }
}
